import { EventEmitter, Injectable, Output } from '@angular/core';

@Injectable()
export class NotificationService {

    @Output() getUpdatedNotificationList: EventEmitter<any> = new EventEmitter();

    constructor() {

    }

    updateLastNotificationsList(): any {
        this.getUpdatedNotificationList.emit();
    }

}


// WEBPACK FOOTER //
// ./ClientApp/app/_services/notification.service.ts